import Reveal from "./Reveal";

export default function Features() {
  return (
    <section id="feature" className="scroll-mt-24" aria-label="深度专题与热门频道">
      {/* featured deep reads */}
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-900">
          <i className="ri-newspaper-line text-primary-500" />
          深度专题
        </h2>
        <span className="hidden text-xs text-foreground-400 sm:block">编辑部每周精选 · 换个视角看热点</span>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-2">
        {[
          {
            ...{
              img: "https://readdy.ai/api/search-image?query=modern%20broadcast%20studio%20interior%20with%20ring%20lights%20and%20screens%20blurred%20in%20foreground%2C%20warm%20cinematic%20lighting%2C%20editorial%20documentary%20photography%2C%20deep%20depth%20of%20field%2C%20high%20detail%2C%20introspective%20mood&width=1200&height=675&seq=feature-fa1-2026&orientation=landscape",
            },
            tag: "深度专题",
            title: "直播间里消失的「真实感」：我们如何被算法推着向前",
            excerpt:
              "从「3、2、1 上链接」到「家人们理性消费」，直播电商用十年跑完一个轮回。本文走进主播、运营与消费者三方视角，拆解一场秒没背后的流量逻辑、信任成本与情绪价值。",
            reads: "186 万阅读",
            time: "12 分钟",
          },
          {
            img: "https://readdy.ai/api/search-image?query=film%20editing%20suite%20with%20warm%20monitor%20glow%20and%20timeline%20clips%2C%20behind%20the%20scenes%20of%20tv%20series%20production%2C%20editorial%20documentary%20photography%2C%20cinematic%20warm%20tone%2C%20high%20detail&width=1200&height=675&seq=feature-fa2-2026&orientation=landscape",
            tag: "深度专题",
            title: "一部爆款剧背后：热搜是造出来的，还是长出来的？",
            excerpt:
              "从「自来水安利」到「数据飞轮」，我们拆解口碑剧集的出圈路径。究竟哪些热度真实可感，哪些只是营销脚本？这一次，我们和编剧、剪辑、舆情从业者聊了聊。",
            reads: "143 万阅读",
            time: "9 分钟",
          },
        ].map((f, i) => (
          <Reveal key={f.title} delay={i * 80}>
            <article className="group relative overflow-hidden rounded-2xl border border-background-200/70 bg-background-100">
              <div className="relative h-52 w-full overflow-hidden md:h-60">
                <img
                  src={f.img}
                  alt={f.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  width={1200}
                  height={675}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent" />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded bg-background-50/90 px-2 py-1 text-[11px] font-semibold text-primary-700">
                  <i className="ri-focus-3-line" />
                  {f.tag}
                </span>
              </div>
              <div className="relative p-4 md:p-5">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-900 group-hover:text-primary-700 md:text-xl">
                  {f.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{f.excerpt}</p>
                <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
                  <span className="inline-flex items-center gap-3">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-eye-line" />
                      {f.reads}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-time-line" />
                      阅读约 {f.time}
                    </span>
                  </span>
                  <a
                    href="#channels"
                    className="inline-flex items-center gap-1 whitespace-nowrap font-semibold text-primary-600 hover:text-primary-700"
                  >
                    阅读全文
                    <i className="ri-arrow-right-line" />
                  </a>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}